<nav class="navbar navbar-expand-lg navbar-light bg-light border-bottom">
    <div class="show collapsed navbar-collapse d-flex flex-row">
        <ul class="navbar-nav mr-auto flex-row">
            <li class="nav-item pr-2">
                <a
                    class="nav-link"
                    (click)="collapsePushed()"
                    role="button"
                    data-toggle="collapse"
                    data-target=".multi-collapse"
                    aria-controls="navbarToggleExternalContent"
                    aria-expanded="false"
                    aria-label="Toggle sidebar"
                >
                    <i class="pi pi-fw pi-bars"></i>
                </a>
            </li>
        </ul>
        <div class="page-title" *ngrxLet="routeData$ as routeData">
            <span *ngIf="routeData && routeData['title']">{{ routeData['title'] | translate }}</span>
        </div>
        <ul class="navbar-nav ml-auto flex-row">
            <li class="nav-item pr-2">
                <p-avatar icon="pi pi-bell" pBadge value="4"></p-avatar>
            </li>
            <li class="nav-item dropdown">
                <p-avatar icon="pi pi-user" class="group-reverse" data-toggle="dropdown">
                    <i class="pi pi-angle-down"></i>
                </p-avatar>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item navbar-font"
                        ><i class="pi pi-fw pi-cog"></i><span class="pl-2">{{ 'PROFILE_PAGE_TITLE' | translate }}</span></a
                    >
                    <a class="dropdown-item navbar-font"><i class="pi pi-fw pi-info-circle"></i><span class="pl-2">Onboarding</span></a>
                    <a class="dropdown-item navbar-font"
                        ><i class="pi pi-fw pi-question-circle"></i><span class="pl-2">{{ 'NAVIGATION_TOP_SUPPORT' | translate }}</span></a
                    >
                    <a class="dropdown-item navbar-font"
                        ><i class="pi pi-fw pi-exclamation-triangle"></i><span class="pl-2">{{ 'NAVIGATION_TOP_BUG' | translate }}</span></a
                    >
                    <a class="dropdown-item navbar-font"
                        ><i class="pi pi-fw pi-question-circle"></i><span class="pl-2">{{ 'NAVIGATION_TOP_ADMIN_MESSAGE' | translate }}</span></a
                    >
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item navbar-font" (click)="signOut()"
                        ><i class="pi pi-fw pi-sign-out"></i><span class="pl-2">{{ 'NAVIGATION_TOP_LOGOUT' | translate }}</span></a
                    >
                </div>
            </li>
        </ul>
    </div>
</nav>
